import { Divider } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';

export const SidebarDivider = () => {
    const theme = useTheme();

    return (
        <Divider
            sx={{
                borderColor: alpha(theme.palette.common.white, 0.12),
                my: 1,
            }}
        />
    );
};
